import { connect } from 'react-redux';
import { ItemsView } from './ItemsView';
import {
    popularBcbsCarriersSelector,
    fetchPopularBcbsCarriersIfNeeded as fetchPopular,
} from '../../../data/popular-carriers';
import { fetchBcbsCarriersIfNeeded as fetchAll, bcbsCarriersSelector } from '../../../data/carriers';
import {
    chooseCarrier,
    showAllForTab,
    changeFocus,
    viewPlanTab,
    viewInsuranceTab,
} from '../../../data/dropdown-state/dropdownStateActions';
import { getDropdownState } from '../../../data/dropdown-state';
import { TAB } from '../../../constants';

export function mapStateToProps(state) {
    const baseConfig = {
        itemName: 'bcbs',
        isLoading: true,
        popularItems: [],
        allItems: [],
    };

    const all = bcbsCarriersSelector(state);
    const popular = popularBcbsCarriersSelector(state);
    const dropdownState = getDropdownState(state);

    if ((!popular || !popular.length)
        && (!all || !all.length)) {
        return baseConfig;
    }

    return {
        ...baseConfig,
        ...dropdownState,
        isLoading: false,
        popularItems: popular,
        allItems: all,
        selected: dropdownState.carrier || { },
        tab: dropdownState.tab,
        showAll: dropdownState.showAll[TAB.BCBS] === true,
        previousTab: props => (() => props.viewInsuranceTab()),
        nextTab: props => () => {
            if (!dropdownState.planDisabled) {
                props.viewPlanTab();
            }
        },
        showChooseLaterOption: false,
    };
}

export const mapDispatchToProps = {
    fetchAll,
    fetchPopular,
    clickHandler: chooseCarrier,
    showAllForTab,
    changeFocus,
    viewPlanTab,
    viewInsuranceTab,
};

export const BcbsConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItemsView);
